import { createContext, useContext } from 'react';
import {
  appConfig,
  privacyPolicy,
  termsOfService,
} from '../content/siteContent';

const AppContext = createContext(null);

export function AppProvider({ children }) {
  return (
    <AppContext.Provider value={{
      appConfig,
      privacyPolicy,
      termsOfService,
      loading: false,
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}
